"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "tw-bg-white tw-shadow-lg tw-rounded-lg tw-pointer-events-auto" };
var _hoisted_2 = { class: "tw-rounded-lg tw-shadow-xl tw-overflow-hidden" };
var _hoisted_3 = { class: "tw-p-4" };
var _hoisted_4 = { class: "tw-flex tw-items-start" };
var _hoisted_5 = {
    key: 0,
    class: "tw-flex-shrink-0"
};
var _hoisted_6 = { class: "tw-ml-3 tw-w-0 tw-flex-1 tw-pt-0.5" };
var _hoisted_7 = {
    key: 0,
    class: "tw-text-sm tw-leading-5 tw-font-medium tw-text-gray-900 tw-mb-0"
};
var _hoisted_8 = { class: "tw-ml-4 tw-flex-shrink-0 tw-flex" };
var store_1 = require("./store");
var icons_1 = require("./icons");
exports.default = (0, vue_1.defineComponent)({
    name: 'Notification',
    props: {
        notification: null
    },
    setup: function (__props) {
        var closeNotification = function (id) {
            store_1.default.actions.removeNotification(id);
        };
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (__props.notification.type)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                    (__props.notification.type === 'success')
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(icons_1.SuccessIcon), { key: 0 }))
                                        : (__props.notification.type === 'info')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(icons_1.InfoIcon), { key: 1 }))
                                            : (__props.notification.type === 'warning')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(icons_1.WarningIcon), { key: 2 }))
                                                : (__props.notification.type === 'error')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(icons_1.ErrorIcon), { key: 3 }))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (__props.notification.title)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_7, (0, vue_2.toDisplayString)(__props.notification.title), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("p", {
                                    class: (0, vue_2.normalizeClass)("".concat(__props.notification.title ? 'tw-mt-1' : '', " tw-text-sm tw-leading-5 tw-text-gray-500 tw-mb-0"))
                                }, (0, vue_2.toDisplayString)(__props.notification.content), 3)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("button", {
                                    onClick: _cache[0] || (_cache[0] = function () { return closeNotification(__props.notification.id); }),
                                    class: "tw-bg-transparent tw-inline-flex tw-text-gray-400 focus:tw-outline-none focus:tw-text-gray-500 tw-transition-all tw-ease-in-out tw-duration-150"
                                }, [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(icons_1.CloseIcon))
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
